// extracted by mini-css-extract-plugin
export default {"additional_item":"KP","info_wrapper":"LP","addition_item_img_wrapper":"MP","title":"NP","quantity":"OP","flavors":"PP","old_price":"QP","discount":"RP","button_wrapper":"SP"};
    if(module.hot) {
      // 1730991509039
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  